export let ApprovalStepStatus;
(function (ApprovalStepStatus) {
  ApprovalStepStatus["APPROVAL_PENDING"] = "APPROVAL_PENDING";
  ApprovalStepStatus["APPROVED"] = "APPROVED";
  ApprovalStepStatus["REJECTED"] = "REJECTED";
  ApprovalStepStatus["WAITING"] = "WAITING";
})(ApprovalStepStatus || (ApprovalStepStatus = {}));